import React from 'react';

export function Loader() {
    return (
        <div className='flex justify-center flex-col' style={{ height: '100vh' }}>
            <p className='text-center' style={{fontSize: '24px'}}>Chargement...</p>
        </div>
    );
}
